import { initGraphQLTada } from 'gql.tada';
import type { introspection } from './graphql-env.js';
import { GQLScalarTypes } from '@/helpers/gql-scalar-types.js';

export const gql = initGraphQLTada<{
  introspection: introspection;
  disableMasking: true;
  scalars: GQLScalarTypes;
}>();

export const CUSTOMER_FIELDS_WATER_SUPPLIER = gql(`
  fragment CustomerFields on Customer {
    id
    profileId
    accountNumber
    status
    serviceAddresses (
      where: { waterServiceId: { ne: null } }
      limit: null
    ) {
      id
      active
      address {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
      waterService {
        id
        siteNumber
        status
      }
    }
    textEnabled
    emailEnabled
    mailEnabled
    profile {
      id
      type
      name
      firstName
      lastName
      contactAddressId
      contactAddress {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
      billingAddressId
      billingAddress {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
      phones {
        id
        subType
        value
        extension
      }
      emails {
        id
        subType
        value
      }
      perms
    }
    notes
    tags
  }
`);
